/**
 * Humanise a machine key (camelCase / kebab / snake / colon-namespaced) into a
 * Title-case label. Shared by the field normaliser (field labels) and the
 * workflow launcher (workflow titles) so the rule lives in one place.
 *
 * `create-standalone-material` → `Create standalone material`
 * `propagate3DMaterial`        → `Propagate 3D Material`
 * `dimension1Sizes`            → `Dimension 1 Sizes`
 *
 * Digits get their own passes because one `([a-z0-9])([A-Z])` split cannot tell
 * `3D` (one token) from `1Sizes` (two) — it rendered `Propagate3 DMaterial` in
 * the run form. Both shapes occur in the flavour schemas, so neither is the odd
 * one out. See `humanize.test.ts` for the cases.
 */
export const humanizeKey = (key: string): string =>
  key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    // A digit opens its own token, and closes it only when a WORD follows: an
    // acronym (`3D`) has no lowercase after the capital, so it stays glued for
    // the acronym rule below to split.
    .replace(/([A-Za-z])(\d)/g, "$1 $2")
    .replace(/(\d)([A-Z][a-z])/g, "$1 $2")
    // `3DMaterial` → `3D Material`, `URLValue` → `URL Value`.
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/[_:-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^\w/, (char) => char.toUpperCase());
